import { render, staticRenderFns } from "./deliverect-status.vue?vue&type=template&id=7e2723d2"
import script from "./deliverect-status.vue?vue&type=script&lang=ts"
export * from "./deliverect-status.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e2723d2')) {
      api.createRecord('7e2723d2', component.options)
    } else {
      api.reload('7e2723d2', component.options)
    }
    module.hot.accept("./deliverect-status.vue?vue&type=template&id=7e2723d2", function () {
      api.rerender('7e2723d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "orders/deliverect-status.vue"
export default component.exports